import React, {useEffect} from 'react';
import {useModelviewerState} from "./useModelviewerContext";
import {useDeepCompareEffectNoCheck} from "use-deep-compare-effect";


export const ModelViewer = ({
    showGizmo=false,
    onProgressChange=null,
    showToolbar=true,
    enablePan=true,
    enableZoom=true,
    containerId = `3d-modelviewer-container`,
    data,
    adminMode,
    onClose,
    onMediaSelect,
    onChange,
    onGroupItemChange,
    showAnnotations
}) => {
    const {ready} = useModelviewerState();
    console.debug({data})

    useDeepCompareEffectNoCheck(() => {
        if(ready) {
            window['modelViewer']['renderModelViewer']({
                showGizmo: showGizmo,
                onProgressChange: onProgressChange,
                showToolbar: showToolbar,
                enablePan: enablePan,
                enableZoom: enableZoom,
                containerId: containerId,
                data: data,
                adminMode: adminMode,
                onClose: onClose,
                onMediaSelect: onMediaSelect,
                onChange: onChange,
                onGroupItemChange: onGroupItemChange,
                showAnnotations: showAnnotations
            })

        }
    }, [
            ready,
            showGizmo,
            onProgressChange,
            showToolbar,
            enablePan,
            enableZoom,
            containerId,
            data,
            adminMode,
            onClose,
            onMediaSelect,
            onChange,
            onGroupItemChange,
            showAnnotations
        ]
    )

    useEffect(
        () => {
            if(ready) {
                return () => window['modelViewer']['unmount'](containerId)
            }
        }, [
            ready,
            containerId
        ]
    )

    return (
        <div
            id={containerId}
            style={{height: "100%"}}
        />
    )
}